// MhraAlerts.js
// Placeholder MHRA alerts grid: pharmacies down the rows, with columns for
// MHRA alerts managed and MHRA alerts outstanding.
//
// NOTE: data is hard-coded mock for now — no API calls yet.

import React from "react";

const PLACEHOLDER_ROWS = [
  { pharmacy: "Riverside Pharmacy",  managed: 8,  outstanding: 1 },
  { pharmacy: "Highstreet Chemist",  managed: 6,  outstanding: 3 },
  { pharmacy: "Parkside Pharmacy",   managed: 9,  outstanding: 0 },
  { pharmacy: "Canalside Pharmacy",  managed: 4,  outstanding: 5 },
  { pharmacy: "Meadow Pharmacy",     managed: 7,  outstanding: 2 },
  { pharmacy: "Station Pharmacy",    managed: 10, outstanding: 4 },
  { pharmacy: "Orchard Pharmacy",    managed: 5,  outstanding: 8 }
];

export default function MhraAlerts() {
  const th = {
    textAlign: "left", padding: "10px 12px", fontSize: 11, fontWeight: 700,
    textTransform: "uppercase", letterSpacing: 0.4, color: "#6b7280",
    borderBottom: "2px solid #e5e7eb", whiteSpace: "nowrap"
  };
  const td = { padding: "10px 12px", fontSize: 13, borderBottom: "1px solid #f0f1f3" };

  return (
    <div style={{ padding: "16px 20px" }}>
      <h2 style={{ margin: "0 0 4px", fontSize: 20 }}>MHRA alerts</h2>
      <div style={{ fontSize: 13, color: "#6b7280", marginBottom: 16 }}>
        MHRA drug and device alerts managed and outstanding, by pharmacy. Placeholder data for now.
      </div>

      <div style={{ overflowX: "auto", border: "1px solid #e5e7eb", borderRadius: 8, background: "#fff" }}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead style={{ background: "#f9fafb" }}>
            <tr>
              <th style={th}>Pharmacy</th>
              <th style={{ ...th, textAlign: "right" }}>MHRA alerts managed</th>
              <th style={{ ...th, textAlign: "right" }}>MHRA alerts outstanding</th>
            </tr>
          </thead>
          <tbody>
            {PLACEHOLDER_ROWS.map(r => (
              <tr key={r.pharmacy}>
                <td style={{ ...td, fontWeight: 600 }}>{r.pharmacy}</td>
                <td style={{ ...td, textAlign: "right", color: "#166534" }}>{r.managed}</td>
                <td style={{
                  ...td, textAlign: "right",
                  color: r.outstanding > 0 ? "#dc2626" : "#1f2937",
                  fontWeight: r.outstanding > 0 ? 600 : 400
                }}>
                  {r.outstanding}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
